export default "__VITE_ASSET__BasHn3GB__"